import React, { useEffect, useRef, useState } from "react";
import {
    Box, Button, Grid, Stack, TextField,
    MenuItem,
    ListSubheader
} from '@mui/material'

// import { JsonToTable } from "react-json-to-table";
import './table.css'
import { LoadingButton, LocalizationProvider } from "@mui/lab";
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import { Api } from "../../../components/api";
import TreeViewTable from "./TreeViewTable";
import JsonToCsvExport from "./JsonToCsvExport";
import { Form, FormikProvider, useFormik } from "formik";
import { fDateTo } from "../../../utils/formatTime";
import * as Yup from 'yup';
import axios from "axios";
import { format } from "date-fns";
import _ from "lodash";
import { useSnackbar } from "notistack";
import JsonToTable from "./JsonToTable";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Alert,
} from "@mui/material";


export default function LogToTable({ userId }) {

    const { enqueueSnackbar } = useSnackbar();
    const handleSnackbar = ({ variant, message }) => {
        enqueueSnackbar(message, { variant, autoHideDuration: 2000, anchorOrigin: { horizontal: 'right', vertical: 'bottom' } });
    };

    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(50);
    const [openEnd, setOpenEnd] = useState(false);

    const endRef = useRef(null);

    const startIndex = (page - 1) * pageSize;

    const [json, setJson] = useState({});

    const field = json.field;
    const dataArray = Array.isArray(json?.data) ? json.data : [];
    // const sortedData = _.orderBy(dataArray, ["time_in", "date_gps"], ["desc", "desc"]);
    const newData = dataArray.map(item => {
        const newItem = {};
        for (const key in item) {
            // ถ้ามี mapping ใช้ชื่อใหม่, ถ้าไม่มีใช้ชื่อเดิม
            const newKey = field[key] || key;
            newItem[newKey] = item[key];
        }
        return newItem;
    });

    const cleaned = (({ field, ...rest }) => rest)(json);

    const data = Array.isArray(json?.data) ? { ...cleaned, data: newData } : { ...cleaned }

    const originalData = Array.isArray(data?.data) ? data.data : [];

    // ทำ pagination
    const paginatedData = originalData.slice(startIndex, startIndex + pageSize).map((item, idx) => ({
        no: startIndex + idx + 1,
        ...item,
    }));;

    const maxPage = Math.max(1, Math.ceil(originalData.length / pageSize));




    const [devices, setDevices] = useState([])

    const [checked, setChecked] = useState([])
    const [checkedData, setCheckedData] = useState([]);

    const [masterReport, setMasterReport] = useState([])
    const [type, setType] = useState({})

    const [length, setLength] = useState(0)

    const [keyTable, setKeyTable] = useState(format(new Date(), "yyyy-MM-dd-HH-mm-ss.SSS"))


    useEffect(() => {
        Api.get(`https://api.sitgps.com/Tracking/v3/gps_report?type=001`)
            .then((res) => {
                setMasterReport(res.data)

            })
            .catch(err => {
                console.log('err', err)
            })
    }, [])


    useEffect(() => {
        Api.get(`/Tracking/DeviceByUsers?userid=${userId}`).then((res) => {
            var list = res.data.map(d => {
                return {
                    value: d.group_id,
                    label: d.group_name,
                    children: d.device.map(c => {
                        return {
                            value: c.id,
                            label: c.name,
                            value_og: c
                        }
                    })
                }
            });
            setDevices(list)
        }
        ).catch(e => {
            console.log('error', e)
        })
    }, [userId])

    const [openError, setOpenError] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const initialTime = new Date();
    const schema = Yup.object().shape({

    });
    const formik = useFormik({
        initialValues: {
            date_s: fDateTo(initialTime.setHours(0, 0, 0), 'yyyy-MM-dd HH:mm'),
            date_e: fDateTo(initialTime.setHours(23, 59, 59), 'yyyy-MM-dd HH:mm'),
        },
        validationSchema: schema,
        onSubmit: (values, { setSubmitting }) => {
            const startDate = new Date(values.date_s);
            const maxMinutes = toSafeNumber(type?.value?.max_date);
            const maxDate = new Date(startDate.getTime() + maxMinutes * 60 * 1000);

            const endDate = new Date(values.date_e);
            if (endDate > maxDate) {
                handleSnackbar({ variant: "error", message: `เลือกได้ไม่เกินวันที่ ${fDateTo(maxDate, "dd/MM/yyyy HH:mm")} กรุณาเลือกใหม่` })
                setSubmitting()
                return
            }


            if (checked.length > type?.value?.device_max) {
                handleSnackbar({ variant: "error", message: `เลือกได้ไม่เกิน ${type?.value.device_max} กรุณาเลือกใหม่` })
                setSubmitting()
                return
            }


            const { date_s, date_e } = values
            const checked_d = checkedData.map(item => item.value_og)
            const req = {
                dateStart: fDateTo(`${date_s}:00`, 'yyyy-MM-dd HH:mm:ss'),
                dateEnd: fDateTo(`${date_e}:59`, 'yyyy-MM-dd HH:mm:ss'),
                ...(type?.value?.api?.body.value.devices ? { devices: checked } : {}),
                ...(type?.value?.api?.body.value.list ? { list: checked } : {}),
                ...(type?.value?.api?.body.value.devices_new ? { devices_new: checked_d } : {})
            }
            Api.post(`${type?.value?.api?.url}`, req).then((res) => {
                const { data } = res
                setLength(Array.isArray(data?.data) ? data?.data.length : 0)
                setJson(data)
                setPage(1)
                setSubmitting()
                setKeyTable(format(new Date(), "yyyy-MM-dd-HH-mm-ss.SSS"))
            }).catch((e) => {
                setErrorMessage(JSON.stringify({
                    message: e.message,
                    status: e.response?.status,
                    data: e.response?.data,
                }, null, 2));
                setOpenError(true);
                setLength(0)
                setJson([])
                setPage(1)
                setSubmitting()
                setKeyTable(format(new Date(), "yyyy-MM-dd-HH-mm-ss.SSS"))
            })
        }
    })

    const dateStartRef = useRef(null);
    const endInputRef = useRef(null);
    const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

    const { errors, touched, values, isSubmitting, handleSubmit, getFieldProps, setFieldValue } = formik;
    const toSafeNumber = (value) => {
        const n = Number(value);
        return isNaN(n) ? 0 : n;
    };
    return (
        <div><Dialog
            open={openError}
            onClose={() => setOpenError(false)}
        >
            <DialogTitle>เกิดข้อผิดพลาด</DialogTitle>

            <DialogContent>
                <Alert severity="error">
                    {errorMessage}
                </Alert>
            </DialogContent>

            <DialogActions>
                <Button onClick={() => setOpenError(false)}>
                    ตกลง
                </Button>
            </DialogActions>
        </Dialog>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
                <Stack direction="row" spacing={1}>
                    <Box
                        sx={{
                            width: "20%",
                            minWidth: "20%",
                            maxWidth: "20%",
                            height: "100vh",
                            minHeight: 0,
                            maxHeight: "100vh",
                            overflow: "hidden",
                            boxSizing: "border-box",
                        }}
                    >
                        <Box
                            sx={{
                                p: "10px",
                                height: "100%",
                                minHeight: 0,
                                boxSizing: "border-box",
                                overflow: "hidden",
                            }}
                        >
                            <TreeViewTable
                                nodes={devices}
                                checked={checked}
                                setChecked={setChecked}
                                checkedData={checkedData}
                                setCheckedData={setCheckedData}
                                maxHeight="100%"
                                height="100%"
                                multi={!type?.value?.device_only}
                            />
                        </Box>
                    </Box>
                    <Box sx={{ minWidth: "calc(80% - 10px)", maxWidth: "calc(80% - 10px)", minHeight: "calc(100vh)", maxHeight: "calc(100vh)", overflow: "hidden" }}>
                        <Box sx={{ padding: "10px", maxWidth: "100%", overflow: "auto" }}>
                            <FormikProvider value={formik}>
                                <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                                    <Grid container >
                                        <Grid item md={3}>
                                            <TextField
                                                label="ประเภทรายงาน"
                                                fullWidth
                                                autoComplete="off"
                                                name="iframe"
                                                size="small"
                                                select
                                                value={type?.id || ""}
                                                onChange={(e) => {
                                                    const selected = masterReport.find(
                                                        (r) => r.id === e.target.value
                                                    );

                                                    setType(selected);

                                                    if (
                                                        selected?.value?.device_only &&
                                                        checked.length > 1
                                                    ) {
                                                        setChecked([]);
                                                    }
                                                }}
                                            >
                                                {Object.entries(
                                                    [...masterReport]
                                                        .sort((a, b) => {
                                                            const aParts = a.subtype?.split(",") || [];
                                                            const bParts = b.subtype?.split(",") || [];

                                                            const a0 = Number(aParts[0]) || 9999;
                                                            const b0 = Number(bParts[0]) || 9999;

                                                            if (a0 !== b0) return a0 - b0;

                                                            const a1 = Number(aParts[1]) || 9999;
                                                            const b1 = Number(bParts[1]) || 9999;

                                                            return a1 - b1;
                                                        })
                                                        .reduce((groups, report) => {
                                                            const parts = report.subtype?.split(",") || [];

                                                            const key = parts[2] || "OTHER";
                                                            const label = parts[3] || "อื่นๆ";

                                                            if (!groups[key]) {
                                                                groups[key] = {
                                                                    label,
                                                                    reports: []
                                                                };
                                                            }

                                                            groups[key].reports.push(report);

                                                            return groups;
                                                        }, {})
                                                ).flatMap(([key, group]) => [
                                                    <ListSubheader key={`header-${key}`}>
                                                        {group.label}
                                                    </ListSubheader>,

                                                    ...group.reports.map((iframe) => (
                                                        <MenuItem
                                                            key={iframe.id}
                                                            value={iframe.id}
                                                            sx={{ pl: 4 }}
                                                        >
                                                            - {iframe.name}
                                                        </MenuItem>
                                                    ))
                                                ])}
                                            </TextField>
                                        </Grid>
                                        <Grid item md={3} sx={{ pl: 2 }}>
                                            <TextField
                                                disabled={typeof type === "object" && !Array.isArray(type) && Object.keys(type).length === 0}
                                                value={values.date_s}
                                                onChange={(val) => {
                                                    const { value } = val.target
                                                    setFieldValue('date_s', `${fDateTo(value, "yyyy-MM-dd HH:mm")}`);
                                                    setFieldValue('date_e', `${fDateTo(new Date(value).setHours(23, 59, 59), "yyyy-MM-dd HH:mm")}`);
                                                    // endRef.current.focus();
                                                    // endRef.current.click();
                                                }}
                                                type="datetime-local"
                                                size="small"
                                                fullWidth
                                                placeholder="YYYY/MM/DD"
                                                autoComplete="off"
                                                error={Boolean(touched.date_s && errors.date_s)}
                                                helperText={touched.date_s && errors.date_s}
                                                label="วันเวลาเริ่ม"
                                                inputProps={{
                                                    // readOnly: true, 
                                                    max: fDateTo(new Date().setHours(23, 59, 59), "yyyy-MM-dd HH:mm"),
                                                }}
                                            />
                                        </Grid>
                                        <Grid item md={3} sx={{ pl: 2 }} >
                                            <TextField
                                                inputRef={endRef}
                                                disabled={typeof type === "object" && !Array.isArray(type) && Object.keys(type).length === 0}
                                                value={values.date_e}
                                                onChange={(val) => {
                                                    const { value } = val.target
                                                    setFieldValue('date_e', `${fDateTo(value, "yyyy-MM-dd HH:mm")}`);
                                                }}
                                                type="datetime-local"
                                                size="small"
                                                fullWidth
                                                placeholder="YYYY/MM/DD"
                                                autoComplete="off"
                                                error={Boolean(touched.date_e && errors.date_e)}
                                                helperText={touched.date_e && errors.date_e}
                                                label="ถึงวันเวลา"
                                                readOnly={true}
                                                inputProps={{
                                                    // readOnly: true, 
                                                    min: fDateTo(new Date(values.date_s), "yyyy-MM-dd HH:mm"),
                                                    max: fDateTo(new Date().setHours(23, 59, 59), "yyyy-MM-dd HH:mm"),
                                                }}
                                            />
                                        </Grid>
                                        <Grid item md={3} sx={{ pl: 2 }}>
                                            <Stack direction="row" spacing={1}>
                                                <LoadingButton disabled={typeof type === "object" && !Array.isArray(type) && Object.keys(type).length === 0} variant="contained" type="submit" loading={isSubmitting}>ค้นหา</LoadingButton>
                                                <JsonToCsvExport jsonData={data} disabled={length === 0} />
                                            </Stack>
                                        </Grid>
                                    </Grid>
                                </Form>
                            </FormikProvider>
                        </Box>
                        <Box sx={{ padding: "10px", maxWidth: "calc(100% - 10px)", minHeight: "calc(100vh - 110px)", maxHeight: "calc(100vh - 110px)", overflow: "auto" }}>
                            {/* <JsonToTable
                                json={paginatedData}
                                key={`${keyTable}-${page}-${pageSize}`}
                                styles={{ marginButton: "25px" }}
                            /> */}
                            <JsonToTable data={paginatedData} />
                        </Box>
                        <Box sx={{ padding: "10px" }}>
                            <Stack
                                container
                                direction="row"
                                spacing={1} justifyContent="space-between">
                                <Box>
                                    <Button
                                        variant="contained"
                                        disabled={page === 1} onClick={() => setPage(page - 1)} size="small">
                                        Prev
                                    </Button>
                                    <span style={{ margin: "0 10px", userSelect: "none" }}>{maxPage > 0 ? `หน้า ${page} / ${maxPage}` : `หน้า 0 / 0`} </span>
                                    <Button
                                        variant="contained"
                                        disabled={isNaN(maxPage) ? true : page === maxPage}
                                        onClick={() => setPage(page + 1)}
                                        size="small"
                                    >
                                        Next
                                    </Button>
                                </Box>
                                <Box>
                                    <select
                                        size="small"
                                        value={pageSize}
                                        onChange={(e) => {
                                            setPageSize(Number(e.target.value));
                                            setPage(1);
                                        }}
                                    >
                                        <option key={`setPageSize-1`} value={10}>
                                            {10}
                                        </option>
                                        <option key={`setPageSize-2`} value={20}>
                                            {20}
                                        </option>
                                        <option key={`setPageSize-3`} value={30}>
                                            {30}
                                        </option>
                                        <option key={`setPageSize-4`} value={40}>
                                            {40}
                                        </option>
                                        <option key={`setPageSize-5`} value={50}>
                                            {50}
                                        </option>
                                    </select>
                                </Box>
                            </Stack>
                        </Box>
                    </Box>
                </Stack>
            </LocalizationProvider>
        </div>
    );
}